<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

      <qr-edit-gateway
        v-model="showGatewayPopup"
        :sections="specialInfoSingle"
        :form-data="data"
        @edit-all="handleEditAll"
        @save="qrUpdate"
        @cancel="onCancel"
      >
        <template v-slot:preview style="position: relative; min-height: 100%;">
          <div class="sticky-preview">
            <gallery-mobile v-model="data" :orders.sync="data.orders" :qr-svg-data-url="qrSvgDataUrl"/>

          </div>
        </template>
      </qr-edit-gateway>

      <v-row class="pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <gallery-mobile v-model="data" :orders.sync="data.orders" :qr-svg-data-url="qrSvgDataUrl" />
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات کیوار قاب خاطره ها</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="res.title"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام کیوار قاب خاطره ها شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام کیوار قاب خاطره ها"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="res.identifier"
                    :domain-id="res.domain_id"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    readonly
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4">
                <!-- سوییچ و آیکون راهنما -->
                <div class="d-flex align-center">
                  <v-switch
                    v-model="AutoSave"
                    color="primary"
                    class="mt-0 pt-0 shrink"
                    hide-details
                    label="ذخیره خودکار"
                  ></v-switch>

                  <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                  <v-tooltip bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="mr-1"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon small color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </span>
                  </v-tooltip>
                </div>

                <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="text-caption grey--text text--darken-1 mt-1 pr-1"
                  style="line-height: 1.4"
                >
                  تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                </div>
              </div>


              <list-expansion
                v-model="data"
                :components="specialInfo"
                :data="data"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import VideoGalleryMobile from "@/view/pages/otherQrTypes/giftGallery/components/galleryMobile";
import GalleryMobile from "@/view/pages/otherQrTypes/giftGallery/components/galleryMobile.vue";
import QrEditGateway from "@/view/pages/qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editGitfGallery",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    GalleryMobile,
    VideoGalleryMobile,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    QrEditGateway,
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      helpData: [],
      serviceName: "Qrland",
      componentName: "editPhoto",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: true,
      loading: false,
      errors: {},
      data: {},
      security: {},
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
 
        };
  },

  mounted() {
    this.fetchData();
  },

  computed: {
specialInfo() {
  return [
    {
      name: "baseInfo",
      value: "",
      title: this.$t("edit_gift_special_info_special.gift_story"),
      icon: "account-heart-outline",
    },
    {
      name: "imageUploader",
      value: "",
      title: this.$t("edit_gift_special_info_special.profile_image"),
      icon: "camera-plus",
      model: "photo",
    },
    {
      name: "bannerSelector",
      value: "",
      title: this.$t("edit_gift_special_info_special.featured_images"),
      icon: "panorama",
      model: "banner",
    },
    {
      name: "PicSelector",
      value: "",
      title: this.$t("edit_gift_special_info_special.image_gallery"),
      icon: "image-multiple",
    },
    {
      name: "VideoGallery",
      value: "",
      title: this.$t("edit_gift_special_info_special.video_gallery"),
      subtitle: "",
      icon: "video",
    },
    {
      name: "voiceGallery",
      title: this.$t("edit_gift_special_info_special.add_audio_file"),
      icon: "microphone",
      model: "audiosGallery",
    },
    {
      name: "colorPallete",
      value: "",
      title: this.$t("edit_gift_special_info_special.select_color"),
      subtitle: "",
      icon: "format-color-fill",
      model: "pallete",
    },
  ];
},
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    specialInfoSingle() {
  return this.specialInfo.map((item) => ({
    ...item,
    description:
      item.description ||
      this.$t(
        "edit_gitf_special_info_single.default_description",
        {
          title: item.title || "",
        }
      ),
  }));
},

  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    
    onCancel() {
      this.goto('qr/list');
    },
    
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.loading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          let info = data.data.data;
          this.res = data.data;
          this.data = info.data;
          
          if (!this.data.orders) {
            this.$set(this.data, 'orders', [        
              { name: 'profile' },
              { name: 'organizationInfo' },
              { name: 'headerImage' },
              { name: 'memories' }, 
              { name: 'gallery' },
              { name: 'video_gallery' },
              { name: 'audiosGallery' },
              { name: 'website' },
              { name: 'aboutUs' },
          ]);
          }
          if (!this.data.banner.mode) {
             this.$set(this.data.banner, 'mode', 'slider');
          }

        })
        .finally(() => (this.loading = false));
    },

  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "gift");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("_method", "PUT");
      data.append("title", this.res.title);

      data.append("qr_id", this.res.qrId);
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if(final || !this.AutoSave)
            this.$toast.success("گیوار قاب خاطره ها شما با موفقیت ویرایش شد.");
          if(final)
          this.goto("qr/list");
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        orders: [     
            { name: 'profile' },
            { name: 'organizationInfo' },
            { name: 'headerImage' },
            { name: 'memories' }, 
            { name: 'gallery' },
            { name: 'video_gallery' },
            { name: 'audiosGallery' },
            { name: 'website' },
            { name: 'aboutUs' },
        ],
        visitName: "",
        banner: {
          mode: "grid", //grid|slider
          gallery: [
            {
              images: [
                
              ],
              name: "",
            },
          ],
        },
        pallete: {
          headColor: "linear-gradient(to top, #050404FF, #3B1A4CFF)",
          bodyColor: "linear-gradient(to top right , #050404FF, #3B1A4CFF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        gallery: [
          {
            name: "",
            images: [
             
            ],
          },
          {
            name: "",
            images: [
            ],
          },
        ],
        photo: {
          profile: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
          audiosGallery: {
          audios: [
           
          ],
          audioType: "",
        },
         VideoGallery: {
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          title: "",
          description:'',
          slider: false,
          grid: false,
          secondPosition: false,
          name: "",
          images: [
            {
          
            },
          ],
        },
        video_gallery: [
          {
            name: "",
            images: [
              {
             },
            ],
          },
        ],
        organizationName: "",
        subtitle: "",
        website: "",
        memories:[
        ],

        PicSelector: {
          title: "",
          description: "",
          orientation:"horizontal",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          slider: false,
          grid: true,
        },
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          slider: false,
          grid: false,
        },
      };
    }
  }
}
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
